import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//store
import {useAppSelector} from '@/store/hooks';
import {getDashboardStatisticsSelector} from '@/store/organization-dashboard';
//constants
import {AUCTION, FOUND_THE_MISSION, TOTAL_RAISED, TABLES_SALES} from '@/utils/constants';
//types
import {IOrganizationDashboardStatistics} from '@/utils/types';
//components
import MoneyAmountInfoItem from './MoneyAmountInfoItem';
//styles
import {moneyAmountInfoStyle} from './MoneyAmountInfo.styles';

const MoneyAmountInfo: FC = () => {
	const statistics = useAppSelector(getDashboardStatisticsSelector) as IOrganizationDashboardStatistics;

	const {
		moneyColl,
		moneyOutstanding,
		tableColl,
		tableOutstanding,
		auctionColl,
		auctionOutstanding,
		fundMissionColl,
		fundMissionOutstanding,
	} = statistics;

	return (
		<Box sx={moneyAmountInfoStyle.wrapper}>
			<MoneyAmountInfoItem title={TOTAL_RAISED} collected={moneyColl} outstanding={moneyOutstanding} />
			<MoneyAmountInfoItem title={TABLES_SALES} collected={tableColl} outstanding={tableOutstanding} />
			<MoneyAmountInfoItem title={AUCTION} collected={auctionColl} outstanding={auctionOutstanding} />
			<MoneyAmountInfoItem title={FOUND_THE_MISSION} collected={fundMissionColl} outstanding={fundMissionOutstanding} />
		</Box>
	);
};

export default MoneyAmountInfo;
